import React from 'react';
import classnames from 'classnames';
// import PropTypes from 'prop-types';
import {WebUI, setComponentClass, getNid} from '../../wui-core/src/index';
import InputGroupAddon from './InputGroupAddon';
import type {InputGroupProps, InputGroupAddonProps} from './iInputGroup';
import { WithConfigConsumer } from "../../wui-provider/src/context";


const InputGroupComponent: React.FC<InputGroupProps> & {
    Addon?: any;
    Button?: any;
} = (props) => {
    const {className, clsPrefix, simple = false, dir, ...others} = props;
    const {bordered, align} = others;
    const adapterNid = React.useMemo(() => getNid(props), [props]);
    const computedClassName = React.useMemo(
        () =>
            classnames(
                className,
                clsPrefix,
                `${clsPrefix}-${dir}`,
                simple && 'simple',
                { ...setComponentClass({ clsPrefix, bordered, align }) }
            ),
        [className, clsPrefix, dir, simple, bordered, align]
    );

    return (
        <span
            dir={dir}
            {...others}
            className={computedClassName}
            {...adapterNid}
        />
    );
};

// 应用 WebUI 装饰器
const InputGroup = WithConfigConsumer()(WebUI({ name: "input-group" })(React.memo(InputGroupComponent)));

/**
 * 将InputGroupAddon与InputGroupButton组件作为InputGroup的附属组件
 */
const addonMap: Record<string, string> = {
    addon: 'Addon',
    button: 'Button'
};

for (let k in addonMap) {
    // eslint-disable-next-line react/display-name
    (InputGroup as Record<string, any>)[addonMap[k]] = React.forwardRef((props: InputGroupAddonProps, ref: React.Ref<any>) => {
        return <InputGroupAddon ref={ref} addonType={k} {...props} />;
    });
}

// InputGroup.propTypes = propTypes;
export default InputGroup;
